import { render, staticRenderFns } from "./AccumulationPayment.vue?vue&type=template&id=2e6db486&scoped=true&"
import script from "./AccumulationPayment.vue?vue&type=script&lang=ts&"
export * from "./AccumulationPayment.vue?vue&type=script&lang=ts&"
import style0 from "./AccumulationPayment.vue?vue&type=style&index=0&id=2e6db486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6db486",
  null
  
)

export default component.exports